import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/sun': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M494.2 221.9L434.4 181.4 448.1 110.4C450.7 97.2 446.5 83.6 437 74 427.4 64.5 413.8 60.3 400.8 62.9L329.9 76.6 289.5 16.7C274.4-5.6 237.6-5.6 222.5 16.7L182.1 76.6 111.3 62.9C98 60.4 84.5 64.5 75 74.1 65.5 83.7 61.3 97.2 63.9 110.4L77.6 181.4 17.8 221.9C6.6 229.5 0 242 0 255.5S6.7 281.5 17.8 289L77.6 329.5 63.9 400.5C61.3 413.7 65.5 427.3 75 436.8 84.5 446.3 97.9 450.5 111.3 447.9L182.1 434.2 222.5 494.1C230 505.3 242.6 512 256 512S282 505.3 289.5 494.2L329.9 434.3 400.8 448C414.2 450.7 427.6 446.4 437.1 436.9 446.6 427.4 450.7 413.8 448.2 400.6L434.5 329.6 494.3 289.1C505.4 281.6 512.1 269 512.1 255.6 512 242 505.4 229.5 494.2 221.9zM381.3 307.5L398.9 398.7 307.9 381.1 256 458 204.1 381 113.2 398.6 130.8 307.4 54 255.4 130.8 203.4 113.2 112.2 204.2 129.8 256 53 307.9 129.9 398.9 112.3 381.3 203.4 458.1 255.4 381.3 307.5zM256 152C198.7 152 152 198.7 152 256S198.7 360 256 360 360 313.3 360 256 313.3 152 256 152zM256 312C225.1 312 200 286.9 200 256S225.1 200 256 200 312 225.1 312 256 286.9 312 256 312z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/sun.js
// module id = ArEw
// module chunks = 144